var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJatLogoBwPositive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1179.6 679",
    style: {
      enableBackground: "new 0 0 1179.6 679"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#191923;}\n\t.st1{fill:#96E6B3;}\n\t.st2{fill:#96E6B3;stroke:#191923;stroke-width:56.6929;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#191923;stroke-width:45.3543;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:none;stroke:#191923;stroke-width:56.6929;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266,123.1c43.7,0,84.8,17,115.6,47.9s47.9,72,47.9,115.6s-17,84.8-47.9,115.6s-72,47.9-115.6,47.9 s-84.8-17-115.6-47.9s-47.9-72-47.9-115.6s17-84.8,47.9-115.6S222.3,123.1,266,123.1 M266,66.4C144.4,66.4,45.8,165,45.8,286.6 S144.4,506.9,266,506.9s220.2-98.6,220.2-220.2S387.7,66.4,266,66.4L266,66.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M556.6,516.1L434.7,394.2L334.5,494.4l121.9,121.9c27.7,27.7,72.5,27.7,100.2,0l0,0 C584.3,588.6,584.3,543.8,556.6,516.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M153.7,300.5l41.3,41.3c12.1,12.1,31.6,12.1,43.7,0l119.5-119.5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M749.9,369.3c-1.5,0-2.8-0.5-3.8-1.6c-1-1.1-1.5-2.3-1.5-3.6c0-0.8,0.1-1.6,0.2-2.2L804.4,201 c0.5-1.8,1.5-3.4,3-4.8c1.5-1.3,3.6-2,6.2-2h32c2.7,0,4.8,0.7,6.2,2c1.5,1.3,2.5,2.9,3,4.8l59.5,160.8c0.2,0.7,0.2,1.4,0.2,2.2 c0,1.3-0.5,2.5-1.5,3.6c-1,1.1-2.2,1.6-3.8,1.6h-26c-2.5,0-4.3-0.6-5.5-1.8c-1.2-1.2-1.9-2.2-2.2-3.2l-10.8-28h-70.5l-10.8,28 c-0.3,1-1.1,2.1-2.2,3.2c-1.2,1.2-3,1.8-5.5,1.8H749.9z M803.6,304h51.8l-25.8-72L803.6,304z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M980.9,369.3c-1.8,0-3.3-0.6-4.5-1.8c-1.2-1.2-1.8-2.7-1.8-4.5V229h-45.5c-1.7,0-3.1-0.6-4.2-1.8 c-1.2-1.2-1.8-2.6-1.8-4.2v-22.5c0-1.8,0.6-3.3,1.8-4.5c1.2-1.2,2.6-1.8,4.2-1.8h131c1.8,0,3.3,0.6,4.5,1.8 c1.2,1.2,1.8,2.7,1.8,4.5V223c0,1.7-0.6,3.1-1.8,4.2c-1.2,1.2-2.7,1.8-4.5,1.8h-45.2v134c0,1.8-0.6,3.3-1.8,4.5 c-1.2,1.2-2.7,1.8-4.5,1.8H980.9z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M626.1,353.8h31.3c17,0,30.8-13.8,30.8-30.8V214.9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1104,164H555v-27.7c0-16,13-29,29-29h490.9c16,0,29,13,29,29V164z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M555,400.5h549v27.7c0,16-13,29-29,29H584c-16,0-29-13-29-29V400.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJatLogoBwPositive);
export default __webpack_public_path__ + "static/media/JAT_logo_B&W-Positive.64ff0177136b96f2e4c1021f8e0dcc46.svg";
export { ForwardRef as ReactComponent };